export const API_BASE = process.env.VUE_APP_API_ENDPOINT;
export const API_PREFIX = process.env.VUE_APP_API_PREFIX;
export const API_IMPORT = process.env.VUE_APP_API_IMPORT;
